const initialState = {
  loading_manifest: false,
  manifest: [],
  totals: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "LOADING_MANIFEST":
      return {
        ...state,
        loading_manifest: true,
      };
    case "GET_MANIFEST":
      return {
        ...state,
        manifest: action.payload.data,
        totals: action.payload.totals,
        loading_manifest: false,
      };
    case "MANIFEST_UPDATE":
      console.log("updt!");
      return {
        ...state,
        manifest: updateManifest(state, action.payload),
      };
    default:
      return state;
  }
}

const updateManifest = (state, payload) => {
  const manifest = state.manifest;
  const md_find = manifest.findIndex((e) => e.id == payload.id);
  if (md_find !== -1) {
    manifest[md_find] = payload;
  }
  return manifest;
};
